import React, { useEffect, Fragment } from 'react';
import { Card, Col, ListGroup, Row } from 'react-bootstrap';
import { BsCalendar, BsClock } from 'react-icons/bs';
import PerfectScrollBar from 'react-perfect-scrollbar';
import { daysInMonth, formatDate } from '../../../../utils';

const News = (props) => {
  const _handleLoadStockNews = () => {
    props.loadNews(props.symbol);
  };

  useEffect(() => {
    _handleLoadStockNews();
    _handleLoadEvents();
  }, [props.symbol]);

  useEffect(() => {
    const { stockNews } = props;
    if (stockNews && !!stockNews.length) {
      // console.log(stockNews[0])
      props.loadNewsDetail(stockNews[0].ArticleID);
    }
  }, [props.stockNews]);

  const _handleLoadEvents = () => {
    var dt = new Date();
    const _toDate = new Date(new Date(dt).setMonth(dt.getMonth() + 6));
    const _fromDate = new Date(new Date(dt).setMonth(dt.getMonth() - 6));
    const _toYear = _toDate.getFullYear();
    const _toMonth = _toDate.getMonth();
    const _fromYear = _fromDate.getFullYear();
    const _fromMonth = _fromDate.getMonth();

    const firstDay = new Date(_fromYear, _fromMonth, 1);
    const lastDay = new Date(_toYear, _toMonth, daysInMonth(_toMonth, _toYear));

    const paramsEvents =
      'symbol=' +
      props.symbol +
      '&from=' +
      formatDate(firstDay, '-') +
      '&to=' +
      formatDate(lastDay, '-');

    props.loadEvents(paramsEvents);
  };

  const { stockNews, stockEvents, newsDetail, companyInfo } = props;

  // console.log(stockNews, stockEvents, newsDetail);

  return (
    <div className="tab-news">
      <Row className="d-flex">
        <Col md="8">
          <PerfectScrollBar style={{ height: 'calc( 100vh - 310px )' }}>
            <h5 className="mb-0 mt-2 font-weight-bold">Tin tức</h5>
            <ListGroup>
              {stockNews &&
                !!stockNews.length &&
                stockNews.map((item) => (
                  <ListGroup.Item key={item.ArticleID}>
                    <Card style={{ width: '100%', maxHeight: '100px' }}>
                      <Card.Body className="d-flex p-2">
                        {/* {companyInfo && companyInfo.Image && (
                          <img
                            style={{
                              height: 'auto',
                              width: 'auto',
                              maxWidth: '150px',
                              maxHeight: '98px',
                              padding: '5px',
                            }}
                            src={`data:image/png;base64, ${companyInfo.Image}`}
                            alt={companyInfo.FullName}
                          />
                        )} */}
                        <div className="ml-2 d-flex flex-column">
                          <a
                            href={item.URL}
                            target="_blank"
                            className="content-read fz-14"
                          >
                            {item.Title}
                          </a>
                          <div className="d-flex align-items-center title-read fz-12">
                            {item.Source}
                            <BsCalendar className="ml-2 mr-1" />
                            {item.PublishTime.split('T')[0]}
                            <BsClock className="ml-2 mr-1" />
                            {item.PublishTime.split('T')[1]}
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </ListGroup.Item>
                ))}
              {(!stockNews || !stockNews.length) && (
                <p className="text-center fz-14 content-read">
                  Không có dữ liệu
                </p>
              )}
            </ListGroup>
          </PerfectScrollBar>
        </Col>
        <Col md="4" className="pl-0">
          <PerfectScrollBar style={{ height: 'calc( 100vh - 310px )' }}>
            <h5 className="mb-0 mt-2 font-weight-bold">Sự kiện</h5>
            <ListGroup>
              {stockEvents &&
                !!stockEvents.length &&
                stockEvents.map((item) => (
                  <ListGroup.Item key={item.EventID}>
                    <div className="ml-2 d-flex flex-column">
                      <span className="title-read fz-12">
                        <BsCalendar className="mr-2" />
                        {item.DateOrder.split('T')[0]}
                      </span>
                      <a
                        href={item.FileUrl}
                        target="_blank"
                        className="content-read fz-14"
                      >
                        {item.Title}
                      </a>
                    </div>
                  </ListGroup.Item>
                ))}
              {(!stockEvents || !stockEvents.length) && (
                <p className="text-center fz-14 content-read">
                  Không có dữ liệu
                </p>
              )}
            </ListGroup>
          </PerfectScrollBar>
        </Col>
      </Row>
    </div>
  );
};

export default News;
